exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-6b878484]{border:2px solid #00f}", ""]);

// exports
